<template>
  <div
    class="main-width content-height"
    style="padding-top: 17px; padding-bottom: 20px"
    v-loading="loading"
  >
    <!--单位概况-->
    <div class="dw">
      <div
        class="dw-item"
        style="margin-right: 20px; cursor: pointer"
        @click="$router.push({ path: '/unitoverview' })"
      >
        <img src="@/assets/img/dwgk.png" />
        <div class="dw-text">
          <!-- <div v-for="(item,index) in dwgkList" :key="index">{{item.title}}</div> -->
          <div>{{ unitOverviewText }}</div>
        </div>
      </div>
      <div
        class="dw-item"
        style="cursor: pointer"
        @click="$router.push({ path: '/culture' })"
      >
        <img src="@/assets/img/fxhj.png" />
        <div class="dw-text">
          <!-- <div v-for="(item,index) in fxhjList" :key="index">{{item.title}}</div> -->
          <div>{{ cultureText }}</div>
        </div>
      </div>
    </div>
    <!--产业要闻-->
    <div class="cy">
      <div class="cy-lb">
        <el-carousel :interval="3000" height="340px">
          <el-carousel-item v-for="(item, index) in adList" :key="index">
            <img :src="item.pageImages" style="width: 100%; height: 340px" />
            <div v-if="item.bannerTitle" class="lb-text">
              {{ item.bannerTitle }}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="cy-news">
        <div class="cy-news-title">
          <div
            :class="{ 'item-active': item.active }"
            class="item"
            v-for="(item, index) in newsCategory"
            :key="index"
            @click="categoryChange(item.channelId)"
          >
            {{ item.title }}
          </div>
        </div>
        <div
          @click="goDetail(item.contentid)"
          class="news_item"
          v-for="(item, index) in categoryNewsList(currentChannelId)"
          :key="index"
        >
          <div>
            <img
              style="width: 7px; height: 7px; margin-right: 5px"
              src="@/assets/img/point.png"
            />
          </div>
          <div class="news_item_text">{{ item.title }}</div>
          <div class="news_item_date">{{ item.postDate }}</div>
        </div>
      </div>
    </div>
    <!--横屏轮播-->
    <div class="mid-lb">
      <!-- <div class="mid-lb-fx" @click="prev">
        <i class="el-icon-arrow-left"></i>
      </div> -->
      <div style="width: 100%">
        <superslide
          :options="options"
          class="slideBox"
          v-if="yfNewsList.length > 0"
        >
          <div class="bd">
            <ul>
              <li v-for="(c, index) in yfNewsList" :key="index">
                <img
                  :src="c.titleimg"
                  style="cursor: pointer"
                  @click="goLink(c)"
                />
              </li>
            </ul>
          </div>
        </superslide>
        <!-- <el-carousel arrow="never" indicator-position="none" ref="carousel" width="100%" height="101px" :autoplay="false">
          <el-carousel-item v-for="(item, index) in yfNewsList" :key="index">
            <div style="display:flex;">
              <img :src="c.titleimg" v-for="(c,index) in item" :key="index" style="cursor:pointer" @click="goDetail(c.contentid)"/>
            </div>
          </el-carousel-item>
        </el-carousel> -->
      </div>
      <!-- <div class="mid-lb-fx" @click="next">
        <i class="el-icon-arrow-right"></i>
      </div> -->
    </div>
    <!--数据开发-->
    <div class="sj">
      <div style="width: 25%; margin-right: 20px">
        <div class="news-top">
          <div style="flex: 1">
            <div class="sj-title">数据开放</div>
          </div>
        </div>
        <div class="sj-main">
          <img
            style="cursor: pointer"
            class="sj-item"
            v-for="(item, index) in sjList"
            :key="index"
            :src="getResourceUrl(item.imgName)"
            @click="item.link && $router.push({ path: item.link })"
          />
          <!-- <img :src="getResourceUrl(item.imgName)" />
            <div>{{ item.text }}</div> -->
          <!-- </div> -->
        </div>
      </div>
      <div style="width: 75%">
        <div class="news-top">
          <div style="flex: 1">
            <div class="sj-title">产业地图</div>
          </div>
          <!--省市区-->
          <div style="display: flex; margin-right: 10px; line-height: 40px">
            <div style="display: flex">
              <!-- <el-cascader placeholder="请选择要查询的区域" style="width:300px" :props="areaOption()" @change="areaSelect" clearable></el-cascader> -->
              <div style="color: #666666; font-size: 13px">
                酒家个数：{{ statisCount.provincesCount || 0 }} 个省，{{
                  statisCount.cityCount || 0
                }}
                个市，{{ statisCount.districtCount || 0 }} 个区
                <!-- <el-select placeholder="省"></el-select> -->
              </div>
              <!-- <div style="color:#666666">
                {{statisCount.cityCount || 0}}个市
              </div>
              <div style="color:#666666">
                {{statisCount.districtCount || 0}}个区
              </div> -->
            </div>
            <!-- <div style="margin-left:10px;">
              <el-button style="width: 83px;height: 28px;border: 1px solid #666666;border-radius: 7px;background: white;color: #666666;" type="primary" size="mini">查询</el-button>
            </div> -->
          </div>

          <div class="news-after" @click="goAddress()">
            更多查询<img src="@/assets/img/more.png" />
          </div>
        </div>
        <div id="container"></div>
      </div>
    </div>
    <!--图说房县-->
    <div style="margin-top: 30px">
      <div class="news-top">
        <div style="flex: 1">
          <div class="sj-title" style="width: 106px">黄酒新视界</div>
        </div>
        <div class="news-after">更多<img src="@/assets/img/more.png" /></div>
      </div>
      <div class="tsfx">
        <div class="tsfx-video">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
          <div class="tsfx-text">{{ tsfxData && tsfxData.title }}</div>
        </div>
        <div
          class="gif"
          @click="$router.push('/video')"
          style="cursor: pointer"
        >
          <img :src="videoData && videoData.titlePicPath" />
          <div class="tsfx-text">{{ videoData && videoData.videoTitle }}</div>
        </div>
        <div class="tsfx-info">
          <div
            class="tsfx-info-item"
            v-for="(item, index) in fxInfoNewsList"
            :key="index"
            @click="goDetail(item.contentid)"
          >
            <img :src="item.titleimg" style="cursor: pointer" />
            <div class="tsfx-text">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    dwgkList() {
      return this.newsList.filter((item) => item.channelId === 171).slice(0, 2);
    },
    fxhjList() {
      return this.newsList.filter((item) => item.channelId === 172).slice(0, 2);
    },
    categoryNewsList() {
      return (channelId) => {
        return this.newsList
          .filter((item) => item.channelId === channelId)
          .slice(0, 10);
      };
    },
    fxxcNews() {
      return (
        this.newsList.filter((item) => item.channelId === 175).slice(0, 1)[0] ||
        {}
      );
    },
    fxInfoNewsList() {
      return this.newsList.filter((item) => item.channelId === 176).slice(0, 4);
    },
  },
  data() {
    return {
      tsfxData: {},
      videoData: {},
      markers: [],
      statisCount: {},
      options: {
        mainCell: ".bd ul",
        titCell: ".bd li",
        effect: "leftMarquee",
        autoPlay: true,
        vis: 3,
        interTime: 20,
      },
      cultureText: "",
      unitOverviewText: "",
      currentChannelId: 161,
      yfNewsList: [],
      newsCategory: [
        {
          channelId: 161,
          active: true,
          title: "时政要闻",
        },
        {
          channelId: 173,
          active: false,
          title: "产业要闻",
        },
        {
          channelId: 168,
          active: false,
          title: "通知公告",
        },
      ],
      playerOptions: {
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "",
            src: "",
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      sjList: [
        {
          imgName: "jx.jpg",
          text: "年度绩效",
          link: "/info?cid=179",
        },
        {
          imgName: "cp.jpg",
          text: "产品溯源",
        },
        {
          imgName: "zc.jpg",
          text: "政策法规",
          link: "/info?cid=177",
        },
        {
          imgName: "db.jpg",
          text: "目标地标",
          link: "/info?cid=181",
        },
        {
          imgName: "zb.jpg",
          text: "酿酒直播",
        },
        {
          imgName: "jiuicon.jpg",
          text: "酒企黄页",
          link: "/business",
        },
        {
          imgName: "jp.jpg",
          text: "精品展示",
          link: "/goods?type=1",
        },
        {
          imgName: "gd.jpg",
          text: "更多",
        },
      ],
      adList: [],
      loading: false,
      newsList: [],
    };
  },
  methods: {
    getStatisCount() {
      return new Promise((resolve, reject) => {
        this.$axios.get("oasis/em-entity/statisticalCount?typeId=006").then(
          (resp) => {
            if (resp.status == 0 || resp.status == "0") {
              this.statisCount = resp.data;
            }
            resolve();
          },
          () => {
            resolve();
          }
        );
      });
    },
    goLink(data) {
      window.open(data.contentLink);
    },
    goAddress() {
      this.$router.push({ path: "/mapmore" });
      // window.open('https://map.qq.com/?type=marker&isopeninfowin=1&markertype=1&pointx=110.706&pointy=32.0348&name=%E6%B9%96%E5%8C%97%E5%BA%90%E9%99%B5%E7%8E%8B%E9%85%92%E4%B8%9A%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8(%E5%8E%82%E5%8C%BA)&addr=%E6%B9%96%E5%8C%97%E7%9C%81%E5%8D%81%E5%A0%B0%E5%B8%82%E6%88%BF%E5%8E%BF%E5%9F%8E%E5%85%B3%E9%95%87%E5%B1%B1%E7%A5%9E%E5%BA%99&ref=WeChat')
    },
    // areaOption(){
    //   let _this = this;
    //   return {
    //     lazy: true,
    //     checkStrictly: true,
    //     lazyLoad(node, resolve) {
    //         let nodes = [];
    //         let parentid = '100000';
    //         if (node.data && node.data.value) {
    //             parentid = node.data.value;
    //         }
    //         _this.$axios.get('hqconsole/utility/arealist?parentid=' + parentid).then(resp => {
    //             if (resp.errcode == 0 || resp.errcode == '0') {
    //                 for (var i = 0; i < resp.data.length; ++i) {
    //                     nodes.push({ label: resp.data[i].areaname, value: resp.data[i].id, leaf: resp.data[i].atype === 3 ? true : false });
    //                 }
    //                 resolve(nodes);
    //             } else {
    //                 resolve([]);
    //             }
    //         }, () => {
    //             resolve([]);
    //         });
    //     }
    //   }
    // },
    areaSelect() {},
    geVideoList() {
      return new Promise((resolve, reject) => {
        let vue = this;
        this.$axios
          .get("fx-web/wine/video/pager", {
            params: { pageNum: 1, pageSize: 1000 },
          })
          .then(
            function (resp) {
              if (resp.errcode == 0 || resp.errcode == "0") {
                let data = resp.data.dataList.find(
                  (item) => item.isShow.toString() == "1"
                ); //1展示2不展示
                if (data) {
                  vue.videoData = data;
                } else {
                  vue.videoData = resp.data.dataList[0];
                }
              } else {
                vue.$message.warning(resp.errtext);
              }
              resolve();
            },
            function () {
              resolve();
            }
          );
      });
    },
    goDetail(contentid) {
      this.$router.push({
        path: "/news/detail",
        query: {
          contentId: contentid,
        },
      });
    },
    //切换幻灯片
    prev() {
      this.$refs.carousel.prev();
    },
    next() {
      this.$refs.carousel.next();
    },
    //获取图说房县
    getTsfx() {
      return new Promise((resolve, reject) => {
        this.$axios
          .get("fx-web/wine/picture/pager", {
            params: { pageNum: 1, pageSize: 1 },
          })
          .then(
            (resp) => {
              if (resp.errcode == 0 || resp.errcode == "0") {
                this.tsfxData = resp.data.dataList[0];
                if (resp.data.dataList[0]) {
                  this.$set(
                    this.playerOptions,
                    "poster",
                    resp.data.dataList[0].titlePicPath
                  );
                  this.$set(this.playerOptions, "sources", [
                    { type: "", src: resp.data.dataList[0].videoPath },
                  ]);
                }
              }
              resolve();
            },
            () => {
              resolve();
            }
          );
      });
    },
    //获取单位概况
    getUnitOverview() {
      return new Promise((resolve, reject) => {
        this.$axios
          .get("fx-web/wine/fxProbably/pager", {
            params: { pageNum: 1, pageSize: 10 },
          })
          .then(
            (resp) => {
              if (resp.errcode == 0 || resp.errcode == "0") {
                this.unitOverviewText =
                  resp.data.dataList[0].probablyContent
                    .replace(/<[^<>]+>/g, "")
                    .replace(/&nbsp;/gi, "") || "";
              }
              resolve();
            },
            () => {
              resolve();
            }
          );
      });
    },
    //获取黄酒文化
    getCulture() {
      return new Promise((resolve, reject) => {
        this.$axios
          .get("fx-web/wine/culture", {
            params: { pageNum: 1, pageSize: 1, Id: 1 },
          })
          .then(
            (resp) => {
              if (resp.errcode == 0 || resp.errcode == "0") {
                this.cultureText =
                  resp.data[0].cultureContent
                    .replace(/<[^<>]+>/g, "")
                    .replace(/&nbsp;/gi, "") || "";
              }
              resolve();
            },
            () => {
              resolve();
            }
          );
      });
    },
    categoryChange(channelId) {
      this.newsCategory.forEach((item) => {
        item.active = item.channelId == channelId ? true : false;
      });
      this.currentChannelId = channelId;
    },
    getResourceUrl(imgName) {
      return require("@/assets/img/" + imgName);
    },
    //获取轮播图
    getAd: function () {
      return new Promise((resolve, reject) => {
        this.$axios
          .get("fx-web/wine/page/banner", {
            params: { pageNum: 1, pageSize: 10 },
          })
          .then(
            (resp) => {
              if (resp.errcode == 0 || resp.errcode == "0") {
                this.adList = resp.data.dataList;
              }
              resolve();
            },
            () => {
              resolve();
            }
          );
      });
    },
    //获取新闻
    getNews: function () {
      return new Promise((resolve, reject) => {
        this.$axios
          .get("rrb-web/news/content/ext/list", {
            params: { pageNum: 1, pageSize: 1000, channelId: "" },
          })
          .then(
            (resp) => {
              if (resp.errcode == 0 || resp.errcode == "0") {
                let result = resp.data.dataList;
                // let temp = result.filter(item => item.channelId === 174);
                // //构建腰封新闻二维数组
                // for (let index = 0; index <  Math.ceil(temp.length/3); index++) {
                //   this.yfNewsList[index] = [];
                //   for (let i = 3*index; i < (3*index + 3); i++) {
                //     temp[i] && this.yfNewsList[index].push(temp[i]);
                //   };
                // };
                result.forEach((item) => {
                  item.postDate = item.postDate
                    ? item.postDate.split(" ")[0]
                    : "";
                });
                this.newsList = result;
                this.yfNewsList = result.filter(
                  (item) => item.channelId === 174
                );
              }
              resolve();
            },
            () => {
              resolve();
            }
          );
      });
    },
    //获取酒家个数
    getStore() {
      return new Promise(
        (resolve, reject) => {
          let _this = this;
          this.$axios
            .get("oasis/em-entity/pager", {
              params: { typeId: "006", pageNum: 1, pageSize: 1000 },
            })
            .then((resp) => {
              if (resp.status == 0 || resp.status == "0") {
                let map = new AMap.Map("container", {
                  resizeEnable: true,
                  zoom: 6,
                });
                resp.data.dataList.forEach((item, index) => {
                  if (item.latitude && item.longitude) {
                    // let icon = new AMap.Icon({
                    //   image: (index + 1) + ".png",
                    //   size: new AMap.Size(50, 60),
                    // });
                    let marker = new AMap.Marker({
                      // icon: icon,
                      position: [item.latitude, item.longitude], //纬度经度
                      offset: new AMap.Pixel(-12, -12),
                      zIndex: 101,
                      title: item.name,
                      map: map,
                    });
                    AMap.event.addListener(marker, "click", function () {
                      // _this.markers.forEach((m,i) =>{
                      //   if(i == index){
                      //     m.setIcon(
                      //       new AMap.Icon({
                      //         image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
                      //         size: new AMap.Size(50, 60),
                      //       }));
                      //   }else{
                      //     m.setIcon(new AMap.Icon({
                      //       image: (i + 1) + ".png",
                      //       size: new AMap.Size(50, 60),
                      //     }));
                      //   };
                      // });
                      new AMap.InfoWindow({
                        anchor: "bottom-center",
                        content: item.name,
                        offset: new AMap.Pixel(-3, -17),
                      }).open(map, marker.getPosition());
                    });
                    _this.markers.push(marker);
                  }
                });
                map.setFitView();
              }
              resolve();
            });
        },
        () => {
          resolve();
        }
      );
    },
    //初始化信息
    async initData() {
      // this.loading = true;
      await this.getUnitOverview();
      await this.getCulture();
      await this.getAd();
      await this.getNews();
      await this.getTsfx();
      await this.getStatisCount();

      await this.geVideoList();
      await this.getStore();
      // this.loading = false;
    },
  },
  created() {
    this.initData();

    this.$nextTick(() => {
      let map = new AMap.Map("container", {
        resizeEnable: true,
        center: [110.73, 32.07],
        zoom: 8,
      });
      new AMap.DistrictSearch({
        extensions: "all",
        subdistrict: 1,
      }).search("420325", function (status, result) {
        // 外多边形坐标数组和内多边形坐标数组
        var outer = [
          new AMap.LngLat(-360, 90, true),
          new AMap.LngLat(-360, -90, true),
          new AMap.LngLat(360, -90, true),
          new AMap.LngLat(360, 90, true),
        ];
        var holes = result.districtList[0].boundaries;

        var pathArray = [outer];
        pathArray.push.apply(pathArray, holes);
        var polygon = new AMap.Polygon({
          pathL: pathArray,
          strokeColor: "#00eeff",
          strokeWeight: 1,
          fillColor: "#71B3ff",
          fillOpacity: 0.5,
        });
        polygon.setPath(pathArray);
        map.add(polygon);
      });
    });
  },
};
</script>
<style scoped lang="scss">
.dw {
  display: flex;
  color: #666666;
  &-item {
    display: flex;
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.06);
    width: 50%;
    background-color: #ffffff;
    height: 60px;
  }
  img {
    width: 60px;
    height: 60px;
  }
  &-text {
    padding: 0px 15px 0px 15px;
    div {
      cursor: pointer;
      line-height: 19px;
      overflow: hidden;
      // white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 420px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-indent: 20px;
    }
    div:hover {
      color: #035ab1;
    }
  }
}

.cy {
  display: flex;
  margin-top: 15px;
  &-lb {
    width: 50%;
    height: 340px;
    margin-right: 20px;
  }
  .lb-text {
    padding-left: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10000;
    position: absolute;
    height: 40px;
    bottom: 0px;
    font-size: 14px;
    width: 100%;
    line-height: 40px;
    color: #ffffff;
    font-weight: 400;
  }
  &-news {
    width: 48%;
    height: 340px;
  }
  &-news-title {
    display: flex;
    color: #666666;
    margin-bottom: 15px;
    .item {
      width: 100px;
      height: 35px;
      background: #f7f5f5;
      line-height: 35px;
      text-align: center;
      border-radius: 5px;
      margin-right: 15px;
      cursor: pointer;
    }
    .item:hover {
      color: #ffffff;
      background: #045ab2 !important;
    }
  }
}
.item-active {
  color: #ffffff;
  background: #045ab2 !important;
}
.mid-lb {
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
  &-fx {
    width: 25px;
    height: 100px;
    background: #dee3e7;
    border-radius: 3px;
    color: #bcb6b2;
    font-size: 20px;
    line-height: 100px;
    text-align: center;
    // margin-top: 27.5px;
    cursor: pointer;
  }
  &-fx:hover {
    i {
      color: #035ab1;
    }
  }
  img {
    width: 300px;
    height: 100px;
    margin: 0 auto;
  }
}
.sj {
  display: flex;
  &-title {
    width: 100px;
    font-size: 15px;
    text-align: center;
    line-height: 41px;
    font-weight: 500;
    background-repeat: round;
    background: #045ab2;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &-main {
    display: flex;
    flex-wrap: wrap;
  }
  &-item {
    display: flex;
    width: 107px;
    // width: 35%;
    // height: 50px;
    background: #ffffff;
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.06);
    border-radius: 7px;
    margin-top: 20px;
    img {
      width: 38px;
      height: 38px;
      margin: auto;
    }
    div {
      line-height: 50px;
      color: #000000;
      font-size: 14px;
      margin: auto;
    }
  }
  &-item:nth-of-type(odd) {
    margin-right: 10%;
  }
}
#container {
  width: 100%;
  height: 227px;
  margin-top: 20px;
}
::v-deep {
  .video-js {
    width: 402px;
    height: 260px;
  }
}
.tsfx {
  display: flex;
  padding-top: 27px;
  &-video {
    margin-right: 34px;
    text-align: center;
    width: 402px;
    height: 260px;
  }
  &-text {
    color: #666666;
    font-size: 12px;
    margin-top: 7px;
  }
  &-info {
    display: flex;
    flex-wrap: wrap;
    &-item {
      margin: auto;
      text-align: center;
      img {
        width: 150px;
        height: 115px;
      }
    }
  }
}
.gif {
  margin-right: 29px;
  text-align: center;
  img {
    width: 210px;
    height: 260px;
  }
}
::v-deep {
  .amap-info-content {
    color: #035ab1;
  }
  .el-input--small .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
  .el-input__inner {
    border: 1px solid #666666 !important;
    border-radius: 7px;
  }
  .tempWrap {
    width: 100% !important;
  }
}
.slideBox {
  overflow: hidden;
  position: relative;
  .bd {
    position: relative;
    height: 100px;
    z-index: 0;
    li {
      zoom: 1;
      width: 300px;
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}
</style>
